import React, { useState } from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import StockImagesSearch from '../../../common/StockImagesSearch';
import BackgroundStockImagesOrientationSelect from './BackgroundStockImagesOrientationSelect';
import MediaPickersConstants from '../../../MediaPickersConstants';

const BackgroundStockImagesSearch = (props) => {
    const [contextMenuAnchor, setContextMenuAnchor] = useState(undefined);

    const { 
        backgroundStockImagesOrientation, backgroundStockImagesSearchValue, setProperty, loadDefaultBackgroundStockImages,
        backgroundStockImagesSearching, searchBackgroundStockImages, clearBackgroundStockImages, backgroundStockImages 
    } = props;

    const disableClearButton = backgroundStockImagesSearchValue === "" && 
        backgroundStockImagesOrientation === MediaPickersConstants.STOCK_MEDIA_ORIENTATION.HORISONTAL && 
        backgroundStockImages.length == 11;

    const onSearchValueChange = (event) => {
        setProperty('backgroundStockImagesSearchValue', event.target.value);
    };

    const loadBackgroundStockImages = (orientation) => {
        setProperty('backgroundStockImagesSearching', true);
        searchBackgroundStockImages(backgroundStockImagesSearchValue, (orientation || backgroundStockImagesOrientation), 1, MediaPickersConstants.BACKGROUND_STOCK_IMAGES_PER_PAGE, () => {
            setProperty('backgroundStockImagesSearching', false);
        });
    };

    const clearResults = () => {
        setProperty('backgroundStockImagesSearchValue', '');

        const needClearOnlyInput  = backgroundStockImagesSearchValue !== "" &&
            backgroundStockImages.length == MediaPickersConstants.BACKGROUND_STOCK_IMAGES_PER_PAGE;

        if(!needClearOnlyInput) {
            clearBackgroundStockImages();
            loadDefaultBackgroundStockImages();
        }
    }

    const onOrientationChange = (orientation) => {
        setContextMenuAnchor(false);
        loadBackgroundStockImages(orientation);
    }

    return (
        <StockImagesSearch
            clearResults={clearResults}
            disableClearButton={disableClearButton} 
            searchValue={backgroundStockImagesSearchValue}
            isSearching={backgroundStockImagesSearching} 
            onSearchValueChange={onSearchValueChange}
            onSearchValueSubmit={loadBackgroundStockImages}
            contextMenuAnchor={contextMenuAnchor}
            setContextMenuAnchor={setContextMenuAnchor}
            stockImageOrientationSelect={<BackgroundStockImagesOrientationSelect onOrientationChange={onOrientationChange} />}
        />
    );
};

const mapStateToProps = (state) => {
    const { 
        backgroundStockImagesOrientation,
        backgroundStockImagesSearchValue,
        backgroundStockImagesSearching,
        backgroundStockImages,
    } = state.mediaPicker;

    return {
        backgroundStockImages,
        backgroundStockImagesOrientation, 
        backgroundStockImagesSearchValue,
        backgroundStockImagesSearching
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const searchBackgroundStockImages = (keywords, orientation, pageNumber, itemsPerPage, callback) => dispatch(mediaPickerActions.searchBackgroundStockImages(keywords, orientation, pageNumber, itemsPerPage, callback));
    const clearBackgroundStockImages = () =>  dispatch(mediaPickerActions.clearBackgroundStockImages());
    const loadDefaultBackgroundStockImages = () => dispatch(mediaPickerActions.loadDefaultBackgroundStockImages());

    return { 
        setProperty,
        clearBackgroundStockImages,
        loadDefaultBackgroundStockImages,
        searchBackgroundStockImages
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundStockImagesSearch);